import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useSourceFilterSrListViewEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.SourceFilterSrListView, false);

  return Boolean(isEnabled);
}
